import { Box, Typography } from '@mui/material'

import { Fragment, useRef } from 'react'

import { AZURE } from '@features/hooks/LandingZones'

import Datatable from '@components/Datatable'
import Alert from '@components/Alert'
import Link from '@components/Link'

export const Membership = (props) => {

    const { data } = props

    const transformChannelName = (params) => {
        if (params.row.link) return (<Link external href={params.row.link} target={'blank'}>{params.value}</Link>)
        else return <span>params.value</span>
    }

    const headers = useRef({
        channels: [
            {field: 'name', headerName: 'Name', flex: 1, sortable: false, renderCell: transformChannelName},
            {field: 'objectId', headerName: 'Object ID', flex: 1, sortable: false},
            {field: 'mail', headerName: 'Mail', flex: 1, sortable: false}
        ],
        owners: [
            {field: 'name', headerName: 'Name', flex: 1, sortable: false},
            {field: 'type', headerName: 'Type', flex: 1, sortable: false},
            {field: 'objectId', headerName: 'Object ID', flex: 1, sortable: false},
            {field: 'mail', headerName: 'Mail', flex: 1, sortable: false}
        ],
        members: [
            {field: 'name', headerName: 'Name', flex: 1, sortable: false},
            {field: 'type', headerName: 'Type', flex: 1, sortable: false},
            {field: 'objectId', headerName: 'Object ID', flex: 1, sortable: false},
            {field: 'mail', headerName: 'Mail', flex: 1, sortable: false}
        ]
    })

    return (
        <Box sx={{padding: '16px'}}>
            {props.info && (props.provider === AZURE) && (<Alert sx={{mb: 2}} description={props.info} />)}

            {data && data.channels && data.channels.length > 0 && (
                <Fragment>
                    <Typography variant={'h5'} sx={{mt: 3, mb:1}}>Channels ({data.channels.length})</Typography>
                    <Datatable
                        sxGrid={{height: 'auto'}}
                        disableColumnMenu={true}
                        disableColumnSorting={true}
                        headers={headers.current.channels}
                        rows={data.channels}
                        getRowId={(row) => row.id}
                    />
                </Fragment>
            )}

            {data && data.owners && data.owners.length > 0 && (
                <Fragment>
                    <Typography variant={'h5'} sx={{mt: 3, mb:1}}>Owners ({data.owners.length})</Typography>
                    <Datatable
                        sxGrid={{height: 'auto'}}
                        disableColumnMenu={true}
                        disableColumnSorting={true}
                        headers={headers.current.owners}
                        rows={data.owners}
                        getRowId={(row) => row.id}
                    />
                </Fragment>
            )}

            {data && data.members && data.members.length > 0 && (
                <Fragment>
                    <Typography variant={'h5'} sx={{mt: 3, mb:1}}>Members ({data.members.length})</Typography>
                    <Datatable
                        sxGrid={{height: 'auto'}}
                        disableColumnMenu={true}
                        disableColumnSorting={true}
                        headers={headers.current.members}
                        rows={data.members}
                        getRowId={(row) => row.id}
                    />
                </Fragment>
            )}
        </Box>
    )
}

export default Membership